import { createSlice } from "@reduxjs/toolkit";
import { deleteSubscriptionUsage } from "./thunks";
import { toast } from "react-toastify";

interface SubscriptionUsageState {
  deleting: boolean;
  error: string | null;
}

const initialState: SubscriptionUsageState = {
  deleting: false,
  error: null,
};

const subscriptionUsageSlice = createSlice({
  name: "subscriptionUsage",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      //.addCase(deleteSubscriptionUsage.pending, (state) => {
      //state.deleting = true;
      // state.error = null;
      //})
      //.addCase(deleteSubscriptionUsage.fulfilled, (state) => {
      //  state.deleting = false;
      //   state.error = null;
      // })
      .addCase(deleteSubscriptionUsage.rejected, (state, action) => {
        state.deleting = false;
        state.error =
          (action.payload as any)?.message || "Erro ao excluir utilização.";
        toast.error(state.error);
      });
  },
});

export default subscriptionUsageSlice.reducer;
